import './PlayerDetailsContainer.css'
import PlayerData from '../../data/PlayerData'
import SingleBar from '../SingleBar/SingleBar'
import { useState } from 'react'
import {
  getPlayerStatMap,
  getPlayerVisibleName,
  round2Dp
} from '../../utils/DataUtils'
import DataMissing from '../DataMissing/DataMissing'
import PlayerDetailsFilter from '../PlayerDetailsFilter/PlayerDetailsFilter'

const PlayerDetailsContainer = ({ team, match, playerId }) => {
  const LOCAL_STORAGE_KEY_NUMERATOR = `selectedPlayerStatNumerator${
    match?.match_id || ''
  }`
  const LOCAL_STORAGE_KEY_DENOMINATOR = `selectedPlayerStatDenominator${
    match?.match_id || ''
  }`
  const LOCAL_STORAGE_KEY_PLAYER_SORT_MODE = `selectedPlayerSortMode${
    match?.match_id || ''
  }`

  const [selectedNumerator, setSelectedNumerator] = useState(
    localStorage.getItem(LOCAL_STORAGE_KEY_NUMERATOR) || 'minutes_played'
  )

  const [selectedDenominator, setSelectedDenominator] = useState(
    localStorage.getItem(LOCAL_STORAGE_KEY_DENOMINATOR) || ''
  )

  const [selectedSort, setSelectedSort] = useState(
    localStorage.getItem(LOCAL_STORAGE_KEY_PLAYER_SORT_MODE) || 'playerName'
  )

  const updateSelectedOption = (
    newSelectedOption,
    localStorageKey,
    setFunction
  ) => {
    localStorage.setItem(localStorageKey, newSelectedOption)
    setFunction(newSelectedOption)
  }

  const updateNumerator = (newNumerator) =>
    updateSelectedOption(
      newNumerator,
      LOCAL_STORAGE_KEY_NUMERATOR,
      setSelectedNumerator
    )
  const updateDenominator = (newDenominator) =>
    updateSelectedOption(
      newDenominator,
      LOCAL_STORAGE_KEY_DENOMINATOR,
      setSelectedDenominator
    )
  const updateSort = (newSort) =>
    updateSelectedOption(
      newSort,
      LOCAL_STORAGE_KEY_PLAYER_SORT_MODE,
      setSelectedSort
    )

  const matchStats = getPlayerStatMap(match, team?.team_id, playerId)

  const playerIds = new Set(matchStats.keys())

  const getStatValue = (playerId) => {
    if (selectedDenominator) {
      if (
        !matchStats.get(playerId)[selectedDenominator] ||
        !matchStats.get(playerId)[selectedNumerator]
      ) {
        return 0
      } else {
        return round2Dp(
          matchStats.get(playerId)[selectedNumerator] /
            matchStats.get(playerId)[selectedDenominator]
        )
      }
    }
    return matchStats.get(playerId)[selectedNumerator]
  }

  const statMax = Math.max(
    ...Array.from(playerIds).map((playerId) => getStatValue(playerId))
  )

  const players = PlayerData.filter((player) =>
    playerIds.has(player.player_id)
  ).sort((a, b) =>
    selectedSort === 'playerName'
      ? getPlayerVisibleName(a).localeCompare(getPlayerVisibleName(b))
      : getStatValue(b.player_id) - getStatValue(a.player_id)
  )

  const dataMissing = Array.from(matchStats.values()).length === 0

  return (
    <div className="playerStatsOuterContainer">
      {dataMissing ? (
        <DataMissing />
      ) : (
        <>
          <div>
            <PlayerDetailsFilter
              matchStats={matchStats}
              selectedNumerator={selectedNumerator}
              selectedDenomintator={selectedDenominator}
              selectedSortMode={selectedSort}
              onNumeratorChange={updateNumerator}
              onDenominatorChange={updateDenominator}
              onSortChange={updateSort}
            />
          </div>
          <div className="playerStatsContainer">
            <div
              className="playerStatsScroll"
              style={match && { position: 'relative' }}
            >
              {players.map((player) => (
                <SingleBar
                  key={player.player_id}
                  title={getPlayerVisibleName(player)}
                  colour={team?.team_first_color || '#c4c4c4'}
                  number={getStatValue(player.player_id)}
                  total={statMax}
                />
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default PlayerDetailsContainer
